import axios from "axios";
const logger = require("@/utils/logger");
const auth = require("./auth")
const utils = require("@/utils/utils")

const config = require("config");
const BASE_URL = config.restAPIURL;

export {
  list,
  create,
  remove,
  getQuotas,
  isValid
};

function getQuotas() {
  auth.requireAuthRedirect();
  const url = `${BASE_URL}/admin/quotas`;

  return axios
    .get(url, {
      headers: auth.getHeaders()
    })
    .then(response => {
      return response.data.data.quotas;
    })
    .catch(utils.axiosErrorHandler)
}

function list() {
  auth.requireAuthRedirect();
  const url = `${BASE_URL}/admin/namespaces`;

  return axios
    .get(url, {
      headers: auth.getHeaders()
    })
    .then(response => {
      return response.data.data;
    })
    .catch(utils.axiosErrorHandler)
}

function create(name) {
  auth.requireAuthRedirect();
  const url = `${BASE_URL}/admin/namespaces`;

  return axios
    .post(url, {
      name: name
    }, {
      headers: auth.getHeaders()
    })
}

function remove(name) {
  auth.requireAuthRedirect();
  const url = `${BASE_URL}/admin/namespaces/` + encodeURIComponent(name);
  return axios
    .delete(url, {
      headers: auth.getHeaders()
    })
}

function isValid(namespace) {
  if (!namespace) {
    alert('Please provide a name for the namespace.')
    return false
  }

  if (!/^[a-zA-Z0-9_\-\. ]{5,}$/.test(namespace)) {
    alert("Invalid namespace name: 5 characters mininum, letters, digits, dashes, dots, underscores and spaces please!");
    return false
  }

  return true
}



// WEBPACK FOOTER //
// ./src/utils/namespace-api.js